<template>
  <div
    :class="`inputWrapper tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-start md:tw-items-center tw-gap-[10px] tw-flex-wrap ${
      required ? 'required' : ''
    }`"
  >
    <span class="tw-flex tw-flex-col tw-gap-[4px]">
      <label
        class="tw-relative tw-text-[#231f20] tw-text-[14px] tw-font-medium tw-mb-[0px] tw-leading-[100%]"
        :for="id"
        >{{ label }}</label
      >
      <span
        v-if="sublabel"
        class="tw-text-[#878787] tw-max-w-[300px] tw-flex-wrap tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal] sublabel"
        >{{ sublabel }}</span
      >
    </span>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {},
})
export default class InputWrapper1 extends Vue {
  @Prop({ required: true }) readonly label: string = "";
  @Prop({ required: false, default: "" }) readonly sublabel: string = "";
  @Prop({ required: false, default: false }) readonly required: boolean = false;
  @Prop({ required: false, default: "" }) readonly id: string = "";
}
</script>

<style scoped>
.inputWrapper.required label::after {
  content: "*";
  color: #f7553c;
  /* text/text-14_med */
  font-size: 14px;
  font-family: "Poppins";
  font-weight: 500;
  line-height: 100%;

  position: absolute;
  right: -12px;
  top: -2px;
}

.sublabel {
  font-family: Poppins;
}
</style>
